import React from 'react';

import I18n from '@wetransfer/transfer/modules/i18n';

import { MobileWebContainerProps } from './types';

export const MobileWebContainer = React.memo(function MobileWebContainer({
  className,
  displayName,
  description,
  actions,
  message,
  priceLabel,
}: MobileWebContainerProps) {
  return (
    <div className={className} data-testid="mobileWebContainer">
      <div className="downloader__container">
        <div className="downloader__text-container">
          {displayName}
          <div className="downloader__description">{description}</div>
        </div>
        {priceLabel}
        <div className="downloader__action-container">{actions}</div>
      </div>
      <div className="downloader__divider" />
      {message && (
        <div className="downloader__message-title">
          {I18n.t('transfer.download.message')}
        </div>
      )}
      {message}
    </div>
  );
});
